<template>
  <div id="builds-table">
    <ValidationObserver ref="firmware-management" v-slot="{ invalid, validated, passes }">
      <v-row>
        <v-col cols="3" class="pl-6">
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
        </v-col>
        <v-spacer/>
        <v-col cols="2" class="text-right pr-0">
          <v-btn v-if="$can('createFirmwarePackage')" color="primary" dark fab x-small @click="dialog = true">
            <v-icon>mdi-plus</v-icon>
            
          </v-btn>
          <span class="label pl-2 pt-2">CREATE BUILD</span>
        </v-col>
        <v-col cols="1" class="text-center pl-0">
          <v-icon
            :class="{ 'updating-status' : loading }"
            @click.native="reload"
          >
              mdi-refresh
          </v-icon>
        </v-col>
      </v-row>
      <!-- <div class="search-container-firmware">
        
      </div>  -->
      
      
      <br>
      <v-data-table 
        :headers="fiteredTableHeaders" 
        :items="firmwares" 
        :loading="loading" 
        :search="search"
        class="elevation-1 admin-table"
      >
        <template v-slot:progress>
          <v-progress-linear color="blue" height="2" indeterminate></v-progress-linear>
        </template>
        <template v-slot:item.action="{item}">
				<div class="reports-action-launch" @click="launchRowAction">
					<v-icon>mdi-dots-vertical</v-icon>
					<ActionContainer :ref="item.key" :heading="'Action'" class="report-action-options">
						<ActionItem 
              :disabled="!$can('deleteFirmwarePackage')"
							label="Delete Build"
							icon="mdi-delete"
							@click.native="toggleDeletePrompt(item)"
            />
            <ActionItem 
              v-if="item.active_rollout == ''"
              :disabled="!$can('createFirmwareRollout')"
              label="Create Rollout"
              icon="mdi-plus-circle"
              @click.native="toggleCreatePrompt(item)"
            />
            <ActionItem 
              v-if="item.active_rollout != ''"
              :disabled="!$can('modifyFirmwareRollout')"
              label="Withdraw Rollout"
              icon="mdi-minus-circle"
              @click.native="toggleWithdrawPrompt(item)"
            />
					</ActionContainer>
				</div>
			</template>
      
      </v-data-table>

      <v-row>
        <v-spacer/>
        <v-col cols="8" class="vert-center">
          <div class="aux-pagination-btn">
            <v-btn text>
              <v-icon color="#0000008a" @click="setPage(1)">
                mdi-chevron-double-left
              </v-icon>
            </v-btn>
          </div>
          <v-pagination
            v-model="selectedPage"
            :length="totalPages"
            :total-visible="7"
          ></v-pagination>
          <div class="aux-pagination-btn">
            <v-btn text>
              <v-icon color="#0000008a" @click="setPage(totalPages)">
                mdi-chevron-double-right
              </v-icon>
            </v-btn>
          </div>
        </v-col>
        <v-col cols="1" class="pr-12">
          <v-text-field 
            v-model="selectedPage"
            hide-spin-buttons
            min="0"
            type="number"
            :rules="rules"
          />
        </v-col>
      </v-row>
      <v-dialog v-model="dialog" max-width="600px">
        <v-card>
          <v-card-title>
            <span class="headline">New Firmware Update Package</span>
          </v-card-title>

          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex md12 sm12>
                  <ValidationProvider v-slot="{  }" name="model" rules="required">
                    <v-select 
                      v-model="item.device_model_id" 
                      density="compact" 
                      label="Device Model" 
                      :items="deviceModels"  
                      item-text="model"
                      item-value="id"
                    />
                   <!-- <v-text-field v-model="item.model" required :error-messages="errors" label="Device Model"></v-text-field> -->
                  </ValidationProvider>
                </v-flex>
                <v-flex md12 sm12>
                  <v-text-field v-model="item.rev" label="Model Revision"></v-text-field>
                </v-flex>
                <v-flex md12 sm12>
                  <ValidationProvider v-slot="{ errors }" name="version" rules="required">
                    <v-text-field v-model="item.fw_build_version" required :error-messages="errors" label="Firmware Version"></v-text-field>
                  </ValidationProvider>
                </v-flex>
                <v-flex md12 sm12>
                  <v-textarea v-model="item.description" label="Description" rows="2"></v-textarea>
                </v-flex>
                <v-flex md12 sm12>
                  <ValidationProvider v-slot="{ errors }" name="package" rules="required">
                    <v-file-input v-model="file" required :error-messages="errors" label="Firmware package"></v-file-input>
                  </ValidationProvider>
                </v-flex>
                <v-flex md12 sm12>
                  <v-checkbox v-model="item.force_update" label="Overwrite an existing firmware package if one exists"></v-checkbox>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
            <v-btn :loading="loader" color="blue darken-1" text :disabled="invalid || !validated" @click="passes(save)">
              Save
              <template v-slot:loader>
                <span class="pvcam-btn-loader">
                  <v-icon light>mdi-cached</v-icon>
                </span>
              </template>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      </ValidationObserver>

      <Dialog
        :display="deletePackageConfirm"
        :title="'Delete Firmware Package'"
        :state="deleteState" 
        :res="deletePackageRes"
        @close="toggleDeletePrompt"
      >
        <v-row>
          <v-col cols="2" class="text-center">
            <v-icon large color="orange">mdi-alert</v-icon>
          </v-col>
          <v-col cols="10">
            This firmware build will be permanently deleted.
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="2">
            
          </v-col>
          <v-col cols="10">
            Are you sure you want to proceed?
          </v-col>
        </v-row>
        <v-row>
          <v-spacer></v-spacer>
          <v-btn text @click="toggleDeletePrompt">no</v-btn>
          <v-btn text :loading="deleteState" @click="deleteItem">yes</v-btn>
        </v-row>
      </Dialog>

      <Dialog
        :display="withdrawRolloutConfirm"
        :title="'Withdraw Rollout'"
        :state="withdrawState" 
        :res="withdrawRes"
        @close="toggleWithdrawPrompt"
      >
        <v-row>
          <v-col cols="2" class="text-center">
            <v-icon large color="orange">mdi-alert</v-icon>
          </v-col>
          <v-col cols="10">
            Withdrawing this rollout will make the associated firmware build unavailable for automatic firmware update.
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="2">
            
          </v-col>
          <v-col cols="10">
            Are you sure you want to proceed?
          </v-col>
        </v-row>
        <v-row>
          <v-spacer></v-spacer>
          <v-btn text @click="toggleWithdrawPrompt">no</v-btn>
          <v-btn text :loading="withdrawState"  @click="withdrawRolout">yes</v-btn>
        </v-row>
      </Dialog>

      <Dialog
        :display="createConfirm"
        :title="createRolloutHeader"
        :state="createState" 
        :res="createRes"
        :width="1000"
        @close="toggleCreatePrompt(null)"
      >
      <ValidationObserver ref="firmware-management" v-slot="{ invalid, validated, passes }">
        <v-row>
          <v-col cols="6">
            <v-row>
              <v-col cols="12">
                <v-menu
                  ref="menu"
                  v-model="menu"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                  :close-on-content-click="false" :close-on-click="false"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="displayDate"
                      label="Rollout Time (UTC, Not Before)"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="date"
                  >
                  <v-row dense>
                    <v-col md="4">
                      <v-text-field
                        v-model="time"
                        label="Time"
                        type="time"
                        prepend-icon="mdi-clock-start"
                        dense
                        @click:prepend="timeDialog = true"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <br>
                  <v-row>
                    <v-spacer/>
                    <v-btn text color="primary" @click="menu = false">Discard</v-btn>
                    <v-btn text color="primary" @click="saveDate">SAVE</v-btn>
                  </v-row>
                  </v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" class="pt-12">
                <v-textarea v-model="description" name="input-7-1" label="Description" @change="trimDescription"></v-textarea>
              </v-col>
            </v-row>
            
          </v-col>
          <v-col cols="6">
            <v-row class="pb-0">
              <v-col cols="12" class="pb-0">
                <span class="grey-text">Firmware Version Compatibility</span>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="2" class="pt-6">
                <span>From:</span>
              </v-col>
              <v-col cols="1" class="relative">
                <ValidationProvider v-slot="{ errors }" rules="required">
                  <v-text-field
                    v-model="from.major"
                    hide-spin-buttons
                    required
                    min="0"
                    max="99"
                    type="number"
                    :error-messages="errors" 
                    @change="handleVersionChange"
                  />
                </ValidationProvider>
                <span class="decimel">.</span>
              </v-col>
              <v-col cols="1" class="relative">
                <ValidationProvider v-slot="{ errors }" rules="required">
                  <v-text-field
                    v-model="from.minor"
                    hide-spin-buttons
                    required
                    min="0"
                    max="99"
                    type="number"
                    :error-messages="errors" 
                    @change="handleVersionChange"
                  />
                </ValidationProvider>
                <span class="decimel">.</span>
              </v-col>
              <v-col cols="1">
                <ValidationProvider v-slot="{ errors }" rules="required">
                  <v-text-field
                    v-model="from.patch"
                    hide-spin-buttons
                    required
                    min="0"
                    max="99"
                    type="number"
                    :error-messages="errors" 
                    @change="handleVersionChange"
                  />
                </ValidationProvider>
              </v-col>

              <v-col cols="2" class="pt-6">
                <span>To:</span>
              </v-col>
              <v-col cols="1" class="relative">
                <ValidationProvider v-slot="{ errors }" rules="required">
                  <v-text-field
                    v-model="to.major"
                    hide-spin-buttons
                    required
                    min="0"
                    max="99"
                    type="number"
                    :error-messages="errors" 
                    @change="handleVersionChange"
                  />
                </ValidationProvider>
                <span class="decimel">.</span>
              </v-col>
              <v-col cols="1" class="relative">
                <ValidationProvider v-slot="{ errors }" rules="required">
                  <v-text-field
                    v-model="to.minor"
                    hide-spin-buttons
                    required
                    min="0"
                    max="99"
                    type="number"
                    :error-messages="errors" 
                    @change="handleVersionChange"
                  />
                </ValidationProvider>
                <span class="decimel">.</span>
              </v-col>
              <v-col cols="1">
                <ValidationProvider v-slot="{ errors }" rules="required">
                  <v-text-field
                    v-model="to.patch"
                    hide-spin-buttons
                    required
                    min="0"
                    max="99"
                    type="number"
                    :error-messages="errors" 
                    @change="handleVersionChange"
                  />
                </ValidationProvider>
              </v-col>
              <v-col cols="1">
                <v-btn color="primary" fab x-small :disabled="!firmwareVersionCompatibility || isVersionAboveCurrentFirmware" @click="addRange">
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-card
                  class="mx-auto firmware-rollout-area cm-scroll-bar"
                  max-height="300"
                  tile
                >
                  <v-list dense>
                    <v-list-item-group
                      color="primary"
                    >
                      <v-list-item
                        v-for="(firmware, i) in formattedVersionRanges"
                        :key="i"
                      >
                        <v-list-item-icon>
                          <v-icon color="red" @click="removeRollout(firmware)">mdi-delete</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                          <v-list-item-title>
                            {{ firmware.from_version }} to {{ firmware.to_version }}
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list-item-group>
                  </v-list>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </ValidationObserver>
        

        <v-dialog
          ref="dialog"
          v-model="timeDialog"
          transition="scale-transition"
          persistent
          width="290px"
        >	
          <v-time-picker
            ref="timePicker"
            v-model="selectedTime"
            header-color="third"
            full-width
            scrollable
            ampm-in-title
          >
            <v-spacer></v-spacer>
            <div class="control-container">
              <v-btn text color="primary" @click="timeDialog = false">Discard</v-btn>
              <v-btn text color="primary" @click="saveTime">SAVE</v-btn>
            </div>
          </v-time-picker>
        </v-dialog>

        <v-row>
          <v-spacer></v-spacer>
          <v-btn text @click="toggleCreatePrompt(null)">cancel</v-btn>
          <v-btn text :disabled="formattedVersionRanges.length == 0" @click="toggleRolloutPrompt">submit</v-btn>
        </v-row>
      </Dialog>

      <Dialog
        :display="rolloutConfirm"
        :title="'Confirm Rollout'"
        :state="rolloutState" 
        :res="rolloutRes"
        @close="toggleRolloutPrompt"
      >
        <v-row>
          <v-col cols="2" class="text-center">
            <v-icon large color="orange">mdi-alert</v-icon>
          </v-col>
          <v-col cols="10">
            <div>
              Firmware build <span class="highlight">{{ firmwareTargetVersion }}</span> will be rolled out to the device model <span class="highlight">{{ targetDeviceModel }}</span> no sooner than <span class="highlight">{{ targetTime }}</span>
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="2">
            
          </v-col>
          <v-col cols="10">
            Please enter the word CONFIRM below, then click SUBMIT to create this rollout.
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="2">
            
          </v-col>
          <v-col cols="4">
            <v-text-field v-model="confirm"></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-spacer></v-spacer>
          <v-btn text @click="toggleRolloutPrompt">cancel</v-btn>
          <v-btn text :disabled="!allowRollout" :loading="rolloutState" @click="createFirmwareRollout">submit</v-btn>
        </v-row>
      </Dialog>

      <Dialog
        :display="showError"
        :title="'Error'"
        :state="false" 
        :res="{}"
        @close="showError = false"
      >
        <v-row>
          <v-col cols="2" class="text-center">
            <v-icon large color="red">mdi-alert</v-icon>
          </v-col>
          <v-col cols="10">
            <div>
              An error occurred
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-spacer></v-spacer>
          <v-btn text @click="showError = false">ok</v-btn>
        </v-row>
      </Dialog>

      <Dialog
        :display="showConflictError"
        :title="'Error'"
        :state="false" 
        :res="{}"
        @close="showConflictError = false, fwBuildVersion = null"
      >
        <v-row>
          <v-col cols="2" class="text-center">
            <v-icon large color="red">mdi-alert</v-icon>
          </v-col>
          <v-col cols="10">
            <div>
              Firmware version <span class="highlight">{{ firmwareTargetVersion }}</span> is already in use by a rollout. Please create a firmware build with a build number that is not in use by any rollout.
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-spacer></v-spacer>
          <v-btn text @click="showConflictError = false, fwBuildVersion = null">ok</v-btn>
        </v-row>
      </Dialog>
      
  </div>

</template>

<script>

import { AmplifyEventBus } from "aws-amplify-vue"
import { CreateFirmwarePackage, uploadFirmwarePackage, DeleteFirmwarePackage, getFirmwareBuilds, updateFirmwareRollout, createFirmwareRollout, getDeviceModels } from "@/services/API.js"
import { mapState, mapGetters } from "vuex"
import { checkIfVersionIsAboveLimit } from '@/utils';

import Dialog from '@/components/general/Dialog.vue';
import ActionContainer from '@/components/general/ActionContainer.vue';
import ActionItem from '@/components/general/ActionItem.vue';

import moment from "moment";

import { Logger } from "aws-amplify"
const logger = new Logger("firmware / build tab")

const semver = require('semver')

export default {
  name: "Builds",

  components: {
    Dialog,
    ActionContainer,
    ActionItem
  },

  props: {
    types: {
      type: Array,
      default: () => {
        return []
      },
    },
    update: {
      type: Number,
      default: 0,
    },

    refreshBuilds: {
      type: Number,
      required: false,
      default: 0
    }
  },


  data() {
    return {
      headers: [
        { text: "Created On", value: "created_on_formatted" },
        { text: "Created By", value: "created_by_user_email" },
        { text: "Model", value: "model" },
        { text: "Revision", value: "rev" },
        { text: "Version", value: "version" },
        { text: "Description", value: "description" },
        { text: "Latest Active Rollout", value: "active_rollout"},
        { text: "Actions", value: "action", sortable: false }
      ],
      firmwares: [],
      loading: true,
      loader: false,
      noresult: false,
      dialog: false,
      deleteDialog: false,
      item: {
        sub: "",
        device_model_id: "",
        rev: "",
        fw_build_version: "",
        description: "",
        file_format: "",
        force_update: false,
      },
      file: {},
      search: '',
      deletePackageTarget: {},
      deletePackageConfirm: false,
      deleteState: false,
      deletePackageRes: null,
      withdrawState: false,
      withdrawRes: null,
      withdrawRolloutConfirm: false,
      withdrawTarget: {},
      createConfirm: false,
      createState: false,
      createRes: null,
      createTarget: null,
      rolloutTime: [],
      activePicker: null,
      date: null,
      time: null,
      menu: false,
      timeDialog: false,
      selectedTime: null,
      displayDate: null,
      startDateTime: moment().format("YYYY-MM-DDTHH:mm:ss"),
      from: {
        major: '00',
        minor: '00',
        patch: '00'
      },
      to: {
        major: '00',
        minor: '00',
        patch: '00'
      },
      versionRanges: [],
      description: '',
      rolloutConfirm: false,
      rolloutState: false,
      rolloutRes: null,
      confirm: '',
      deviceModels: [],
      showError: false,
      showConflictError: false,
      refreshRollouts: 0,
      fwBuildVersion: null,
      totalPages: 1,
      page: 1
    }
  },
  computed: {
    ...mapState(["sub"]),
    ...mapGetters(["orgId", "orgName"]),
    selectedPage: {
      get() { 
        return parseInt(this.page); 
      },
      set(newVal) { 
        this.page = parseInt(newVal);
      }
    },
    fiteredTableHeaders () {
      return this.headers.filter(i => !this.hideHeader[i.value])
    },
    hideHeader () {
      return {
        action: !this.$can('deleteFirmwarePackage') && !this.$can('createFirmwareRollout'),
      }
    },
    versionRules() {
      return [
        v => !!v || 'This is required',
        v => v > 0 || 'Minimum value is 0'
      ]
    },
    firmwareFrom() {
      return `${this.from.major}.${this.from.minor}.${this.from.patch}`
    },
    firmwareTo() {
      return `${this.to.major}.${this.to.minor}.${this.to.patch}`
    },
    firmwareFromTrimmed() {
      return `${parseInt(this.from.major)}.${parseInt(this.from.minor)}.${parseInt(this.from.patch)}`
    },
    firmwareToTrimmed() {
      return `${parseInt(this.to.major)}.${parseInt(this.to.minor)}.${parseInt(this.to.patch)}`
    },
    firmwareVersionCompatibility() {
      return semver.gte(this.firmwareToTrimmed, this.firmwareFromTrimmed)
    },
    isVersionAboveCurrentFirmware() {
      const calcPreviousVersion = (item) => {
        logger.info('calcPreviousVersion computed', item)
        let components = item.split('.')
        logger.info('components split', components)
        let versionInfo = {
          major: null,
          minor: null,
          patch: null
        }
        const formatVersionSubStr = (val) => {
          let integer = parseInt(val)

          return integer < 10 ? `0${integer}` : `${integer}`
        }

        const calcPreviousVersion = (version) => {
          if(parseInt(version.patch)  > 0) {
            version.patch = formatVersionSubStr((parseInt(version.patch) - 1))
            logger.info('patch', version)
            return version
          }
          if(parseInt(version.minor)  > 0) {
            version.patch = formatVersionSubStr((parseInt(version.minor) - 1))
            logger.info('minor', version)
            return version
          }
          if(parseInt(version.major)  > 0) {
            version.major = formatVersionSubStr((parseInt(version.major) - 1))
            logger.info('patch', version)
            return version
          }
        }

        

        if(item) {
          components.forEach((sub, index) => {
            if(index == 0) {
              logger.info('0', sub, sub[0])
              versionInfo.major = sub
            }
            if(index == 1) {
              logger.info('1', sub, sub[1])
              versionInfo.minor = sub
            }
            if(index == 2) {
              logger.info('2', sub, sub[0])
              versionInfo.patch = sub
            }
          })

          versionInfo = calcPreviousVersion(versionInfo)
          
          return versionInfo
        }
      }
      const previousVersionObj = calcPreviousVersion(this.createTarget.version)
      const previousVersionStr = `${previousVersionObj.major}.${previousVersionObj.minor}.${previousVersionObj.patch}`

      return this.createTarget ? checkIfVersionIsAboveLimit(this.firmwareTo, previousVersionStr) : false
    },
    firmwareTargetVersion() {
      if(this.createTarget) {
        return this.createTarget.version
      }
      else if(this.fwBuildVersion) {
        return this.fwBuildVersion
      }
      else {
        return ''
      }
    },
    targetDeviceModel() {
      return this.createTarget ? this.createTarget.model : ''
    },
    targetTime() {
      return this.displayDate
    },
    allowRollout() {
      return this.confirm.toLowerCase() == 'confirm'
    },
    formattedDateForRolloutCreation() {
      return moment(this.displayDate).format("YYYY-MM-DDTHH:mm:ss[Z]")
    },
    createRolloutHeader() {
      return this.createTarget ? `Create Firmware Rollout: ${this.createTarget.model}, ${this.createTarget.version}` : ''
    },
    formattedVersionRanges() {
      let ranges = this.versionRanges

      return this.formatRange(ranges)
    }
  },
  watch: {
    dialog(val) {
      val || this.close()
    },
    types(val) {
      logger.info(val)
    },
    update(val) {
      val && this.reload()
    },
    time() {
      logger.info('time value', this.time)
    },
    createConfirm() {
      if(this.createConfirm) {
        this.displayDate = moment().utc().format('D MMM YYYY HH:mm')
        logger.info('what now', moment().format('yyyy-MM-DD'))
        this.date = moment().format('yyyy-MM-DD')
      }
    },
    refreshRollouts() {
      this.$emit('refreshRollouts', this.refreshRollouts)
    },
    refreshBuilds() {
      this.reload()
    },
    page() {
      if(this.page > 0 && this.page <= this.totalPages) {
        this.reload()
      }
    },
  },
  created() {
    this.reload()
    this.getDeviceModels()
  },

  methods: {
    setPage(page) {
      if (!page) return
      this.selectedPage = page
    },

    async getDeviceModels() {
      const models = await getDeviceModels()


      if(models && Object.hasOwn(models, 'device_models')) {
        // added for data team to remove any non cm models
        this.deviceModels = models.device_models.filter(i => i.manufacturer == 'Cameramatics')
      }
    },
    toggleRolloutPrompt() {
      this.rolloutConfirm = !this.rolloutConfirm
    },
    trimDescription() {
      if(this.description.length > 256) {
        this.description = this.description.substring(0, 256)
      }
    },
    handleVersionChange() {
      logger.info('handle change', this.from.major, this.from.major.length, this.from.major.substring(0, 2))
      if(this.from.major.length > 2) {
        this.from.major = this.from.major.substring(0, 2)
      }
      if(this.from.major < 10 && this.from.major.length < 2) {
        this.from.major = `0${this.from.major}`
      }

      if(this.from.minor.length > 2) {
        this.from.minor = this.from.minor.substring(0, 2)
      }
      if(this.from.minor < 10 && this.from.minor.length < 2) {
        this.from.minor = `0${this.from.minor}`
      }

      if(this.from.patch.length > 2) {
        this.from.patch = this.from.patch.substring(0, 2)
      }
      if(this.from.patch < 10 && this.from.patch.length < 2) {
        this.from.patch = `0${this.from.patch}`
      }

      ////////////////////////////

      if(this.to.major.length > 2) {
        this.to.major = this.to.major.substring(0, 2)
      }
      if(this.to.major < 10 && this.to.major.length < 2) {
        this.to.major = `0${this.to.major}`
      }

      if(this.to.minor.length > 2) {
        this.to.minor = this.to.minor.substring(0, 2)
      }
      if(this.to.minor < 10 && this.to.minor.length < 2) {
        this.to.minor = `0${this.to.minor}`
      }

      if(this.to.patch.length > 2) {
        this.to.patch = this.to.patch.substring(0, 2)
      }
      if(this.to.patch < 10 && this.to.patch.length < 2) {
        this.to.patch = `0${this.to.patch}`
      }
    },
    removeRollout(firmware) {
      this.versionRanges = this.formattedVersionRanges.filter(version => version.from_version != firmware.from_version && version.to_version != firmware.to_version)
    },
    addRange() {
      const containsRange = (obj, list) => {
        return list.some(function(elem) {
          return elem === obj
        })
      }

      if(this.versionRanges.length <= 0 && !containsRange({ from_version: this.firmwareFrom, to_version: this.firmwareTo}, this.versionRanges)){
        this.versionRanges.push({
          from_version: this.firmwareFrom,
          to_version: this.firmwareTo
        })
      } else {
        this.versionRanges = this.mergeRanges(this.versionRanges, this.firmwareFrom, this.firmwareTo)
      }
      logger.info('add range', this.versionRanges)
    },
    formatRange(range) {
      let result = []

      const formatVersionSubStr = (val) => {
        logger.info('val', val)
        let components = val.split('.')
        let versionObj = {
          major: '',
          minor: '',
          patch: ''
        }

        components.forEach((sub, index) => {
          if(index == 0) {
            let integer = parseInt(sub)
            
            versionObj.major = integer < 10 ? `0${integer}` : `${integer}`
          }
          if(index == 1) {
            let integer = parseInt(sub)
            
            versionObj.minor = integer < 10 ? `0${integer}` : `${integer}`
          }
          if(index == 2) {
            let integer = parseInt(sub)
            
            versionObj.patch = integer < 10 ? `0${integer}` : `${integer}`
          }
        })
        return `${versionObj.major}.${versionObj.minor}.${versionObj.patch}`
      }
      result = range.map(item => ({ 
        from_version: formatVersionSubStr(item.from_version),
        to_version: formatVersionSubStr(item.to_version)
      }))

      return result
    },
    mergeRanges(ranges, lowerBound, upperBound) {
      logger.info('called mergeRanges', ranges, lowerBound, upperBound)
      let merged = false
      let noMerge = true
      
      const trimVersionAndFormat = (version, versionType = false) => {
        if(!version) return
        let components = version.split('.')
        let versionInfo = {
          major: null,
          minor: null,
          patch: null
        }

        const calcPreviousVersion = (version) => {
          if(parseInt(version.patch)  > 0) {
            version.patch = parseInt(version.patch) - 1
            return version
          }
          if(parseInt(version.minor)  > 0) {
            version.minor = parseInt(version.minor) - 1
            return version
          }
          if(parseInt(version.major)  > 0) {
            version.major = parseInt(version.major) - 1
            return version
          }
        }

        const calcNextVersion = (version) => {
          if(parseInt(version.patch)  < 99) {
            logger.info('version.patch', (version.patch + 1))
            version.patch = (parseInt(version.patch) + 1)
            return version
          }
          if(parseInt(version.minor)  < 99) {
            version.minor = (parseInt(version.minor) + 1)
            return version
          }
          if(parseInt(version.major)  < 99) {
            version.major = (parseInt(version.major) + 1)
            return version
          }
        }

        components.forEach((sub, index) => {
          if(index == 0) {
            versionInfo.major = parseInt(sub)
          }
          if(index == 1) {
            versionInfo.minor = parseInt(sub)
          }
          if(index == 2) {
            versionInfo.patch = parseInt(sub)
          }
        })

        let formattedPreviousVersion = versionInfo

        if(versionType && versionType == 'previous') {
          formattedPreviousVersion = calcPreviousVersion(versionInfo)
        }
        if(versionType && versionType == 'next') {
          formattedPreviousVersion = calcNextVersion(versionInfo)
        }

        if(formattedPreviousVersion) {
          return `${formattedPreviousVersion.major}.${formattedPreviousVersion.minor}.${formattedPreviousVersion.patch}`
        }
        else {
          return '0.0.0'
        } 
      }
      do {
      merged = false

      ranges.some((entry) => {
        logger.info('range some', upperBound, lowerBound, entry)
        let formattedUpperBound = trimVersionAndFormat(upperBound)
        let formattedLowerBound = trimVersionAndFormat(lowerBound)
        let formattedPreviousEntryLowerBound = trimVersionAndFormat(entry.from_version, 'previous')
        let formattedNextEntryUpperBound = trimVersionAndFormat(entry.to_version, 'next')
        let formattedEntryLowerBound = trimVersionAndFormat(entry.from_version)
        let formattedEntryUpperBound = trimVersionAndFormat(entry.to_version)
        logger.info('debugging formatted values', formattedUpperBound, formattedLowerBound, formattedEntryLowerBound, formattedEntryUpperBound)
        if ( !((semver.lt(formattedUpperBound, formattedPreviousEntryLowerBound)) || (semver.gt(formattedLowerBound, formattedNextEntryUpperBound)) || (semver.eq(formattedUpperBound, formattedEntryUpperBound) && semver.eq(formattedLowerBound, formattedEntryLowerBound))) ) {
          // merging required
          let lbVersions = [formattedLowerBound, formattedEntryLowerBound]
          let ubVersions = [formattedUpperBound, formattedEntryUpperBound]

          entry.from_version = semver.minSatisfying(lbVersions, '*')
          entry.to_version = semver.maxSatisfying(ubVersions, '*')
          lowerBound = entry.from_version
          upperBound = entry.to_version
          merged = true
          noMerge = false
          return merged // if true, will stop iteration
        }
      })
      } while ( merged )

      if ( noMerge )
      ranges.push({
        from_version: lowerBound,
        to_version: upperBound
      });  // no overlap, so add (with sorting) new entry
      // Remove duplicates and sort by ascending range lower bound
      let uniqueSet = ranges.filter((o, index, arr) =>
        arr.findIndex(item => JSON.stringify(item) === JSON.stringify(o)) === index
      )
      return uniqueSet.map(e => e).sort((a,b)=>a.from_version-b.from_version)
    },
    calcPreviousVersion(item) {
      if(!item) return
      logger.info('calcPreviousVersion', item)
      let components = item.version.split('.')
      let versionInfo = {
        major: null,
        minor: null,
        patch: null
      }
      const formatVersionSubStr = (val) => {
        let integer = parseInt(val)

        return integer < 10 ? `0${integer}` : `${integer}`
      }

      const calcPreviousVersion = (version) => {
        if(parseInt(version.patch)  > 0) {
          version.patch = formatVersionSubStr((parseInt(version.patch) - 1))
          logger.info('patch', version)
          return version
        }
        if(parseInt(version.minor)  > 0) {
          version.patch = formatVersionSubStr((parseInt(version.minor) - 1))
          logger.info('minor', version)
          return version
        }
        if(parseInt(version.major)  > 0) {
          version.major = formatVersionSubStr((parseInt(version.major) - 1))
          logger.info('patch', version)
          return version
        }
      }

      

      if(item && item.version) {
        components.forEach((sub, index) => {
          if(index == 0) {
            logger.info('0', sub, sub[0])
            versionInfo.major = sub
          }
          if(index == 1) {
            logger.info('1', sub, sub[1])
            versionInfo.minor = sub
          }
          if(index == 2) {
            logger.info('2', sub, sub[0])
            versionInfo.patch = sub
          }
        })

        versionInfo = calcPreviousVersion(versionInfo)
        
        return versionInfo
      }
    },
    formatSemVer(item) {
      if(!item) return
      logger.info('calcPreviousVersion', item)
      let components = item.version.split('.')
      let versionInfo = {
        major: null,
        minor: null,
        patch: null
      }
      const formatVersionSubStr = (val) => {
        let integer = parseInt(val)

        return integer < 10 ? `0${integer}` : `${integer}`
      }

      const formatVersion = (version) => {
        if(parseInt(version.patch)  > 0) {
          version.patch = formatVersionSubStr((parseInt(version.patch)))
          logger.info('patch', version)
          return version
        }
        if(parseInt(version.minor)  > 0) {
          version.patch = formatVersionSubStr((parseInt(version.minor)))
          logger.info('minor', version)
          return version
        }
        if(parseInt(version.major)  > 0) {
          version.major = formatVersionSubStr((parseInt(version.major)))
          logger.info('patch', version)
          return version
        }
      }

      

      if(item && item.version) {
        components.forEach((sub, index) => {
          if(index == 0) {
            logger.info('0', sub, sub[0])
            versionInfo.major = sub
          }
          if(index == 1) {
            logger.info('1', sub, sub[1])
            versionInfo.minor = sub
          }
          if(index == 2) {
            logger.info('2', sub, sub[0])
            versionInfo.patch = sub
          }
        })

        versionInfo = formatVersion(versionInfo)
        
        return versionInfo
      }
    },
    saveTime(time) {
      logger.info('time', time)
      this.timeDialog = false
      logger.info('time', this.selectedTime)
      this.time = this.selectedTime
    },
    saveDate (date) {
      logger.info('save date', date)
      if(this.time) {
        this.date = moment(this.date += ` ${this.time}:00`).format("YYYY-MM-DDTHH:mm:ss")
        logger.info('new date/time', this.date)
      }
      this.displayDate = moment(this.date).utc().format('D MMM YYYY HH:mm')
      this.$refs.menu.save(date)
    },
    launchRowAction(e) {
      let allOptions = document.querySelectorAll(".report-action-options");

      for (let option of allOptions) {
        option.classList.remove('active-options');
        if (option === e.target.nextSibling) {
          option.classList.toggle('active-options');
        } 
      }
    },
    toggleDeletePrompt(item) {
      this.deleteState = false; 
      this.deletePackageRes = null;
      this.deletePackageTarget = item;
      this.deletePackageConfirm = !this.deletePackageConfirm;
    },
    toggleWithdrawPrompt(item) {
      this.withdrawState = false
      this.withdrawRes = null
      this.withdrawTarget = item
      this.withdrawRolloutConfirm = !this.withdrawRolloutConfirm
    },
    toggleCreatePrompt(item) {
      logger.info('toggleCreatePrompt', item)
      this.from.major = '00'
      this.from.minor = '00'
      this.from.patch = '00'
      this.description = ''
      if(item) {
        this.createTarget = item
        this.to = this.calcPreviousVersion(item)
      }
      else {
        this.createTarget = null
        this.versionRanges = []
      }
      this.createConfirm = !this.createConfirm

    },
    async reload() {
      this.loading = true;

      const res = await getFirmwareBuilds(this.page)
      this.loading = false
      if (res && res.Firmware) {
        this.page = res.page_num
        this.totalPages = res.page_size
        this.firmwares = res.Firmware.map(item => ({
          active_rollout: Object.hasOwn(item, 'active_firmware_rollout') ? moment(item.active_firmware_rollout.created_on).utc().format('D MMM YYYY HH:mm') : '',
          created_on_formatted: moment(item.created_on).utc().format('D MMM YYYY HH:mm'),
          ...item
        }))
        this.noresult = true
      }
    },

    async deleteItem() {
      logger.info('debuging delete method', this.deletePackageTarget);
      this.deleteState = true;
      const index = this.firmwares.indexOf(this.deletePackageTarget)
      const res = await DeleteFirmwarePackage(this.deletePackageTarget.firmware_id)

      if (res && Object.hasOwn(res, 'result') && res.result.toLowerCase() == 'deleted') {
        this.firmwares.splice(index, 1);
        this.deleteState = false
        this.deletePackageRes = {
          msg: `Firmware package has been deleted`,
          code: 'green'
        };
      }
      else {
        this.deleteState = false;
        this.deletePackageRes = {
          msg: `An error has occurred`,
          code: 'red'
        };
      }
    },

    close() {
      this.dialog = false
      this.item.sub = ''
      this.item.device_model_id = ''
      this.item.rev = ''
      this.item.fw_build_version = ''
      this.item.description = ''
      this.item.file_format = ''
      this.item.force_update = false
      this.file = {}
    },

    async save() {
      this.loader = true
      const fileArr = this.file.name.split(".")
      this.item = {
        ...this.item,
        sub: this.sub,
        file_format: fileArr[fileArr.length - 1],
      }
      this.fwBuildVersion = this.item.fw_build_version
      const res = await CreateFirmwarePackage(this.item)
      const upload = await uploadFirmwarePackage(this.file, res)

      this.loader = false

      if (res && upload) {
        AmplifyEventBus.$emit("snackEvent", {
          color: "success",
          text: `Firmware package created`,
        })
        logger.info('firmware upload : ', res, upload)
        this.reload()
        this.dialog = false
      }
      else if(res && Object.hasOwn(res, 'message') && res.message.toLowerCase().includes('conflict') || res && Object.hasOwn(res, 'message') && res.message.toLowerCase().includes('[precondition required]')) {
        this.rolloutState = false
        this.rolloutConfirm = false
        this.showConflictError = true
      }
      else {
        logger.info('what', res, res.message.toLowerCase())
        AmplifyEventBus.$emit("snackEvent", {color: "red", text: "An error occurred."})
      }
      this.close()
    },

    async withdrawRolout() {
      try {
        this.withdrawState = true
        logger.info(this.withdrawTarget)
        if(!Object.hasOwn(this.withdrawTarget, 'active_firmware_rollout')) return
        const withdraw = await updateFirmwareRollout(this.withdrawTarget.active_firmware_rollout.fw_rollout_id)
        
        if(withdraw && Object.hasOwn(withdraw, 'result') && withdraw.result == 'Withdrawn') {
          this.firmwares = []
          this.reload()
          this.withdrawState = false
          this.toggleWithdrawPrompt(null)
          this.refreshRollouts++
        } else {
          this.withdrawState = false
          throw new Error('A problem occurred.')
        }
      }

      catch {
        this.withdrawState = false
        throw new Error('A problem occurred.')
      }
    },

    async createFirmwareRollout() {
      this.rolloutState = true
      try {
        const payload = {
            "fw_build_id": this.createTarget.firmware_id,
            "description": this.description,
            "rollout_start": this.formattedDateForRolloutCreation,
            "compatibility": this.formattedVersionRanges
        }
        const createRollout = await createFirmwareRollout(payload)
        logger.info('createRollout', createRollout)
        if(createRollout && Object.hasOwn(createRollout, 'result')) {
          this.firmwares = []
          this.reload()
          this.rolloutState = false
          this.rolloutConfirm = false
          this.createConfirm = false
          this.confirm = ''
          this.refreshRollouts++
        }
        else if (createRollout && Object.hasOwn(createRollout, 'message') && createRollout.message.toLowerCase().contains('conflict')) {
          this.rolloutState = false
          this.rolloutConfirm = false
          this.showConflictError = true
        }
        else {
          logger.info('createRollout failed', createRollout)
          this.rolloutState = false
          this.rolloutConfirm = false
          this.showError = true
        }
      }
      catch {
        this.rolloutState = false
        throw new Error('Error creating rollout.')
      }
    }
  },
}
</script>

<style lang="scss">
  .relative {
    position: relative !important;
  }
  .decimel {
    position: absolute;
    top: 35px;
    right: 0;
  }
  .delete-text {
    text-align: center;
    padding-top: 2em !important;
    font-size: 20px;
  }
  .search-container-firmware {
    width: 20em;
    padding: 0 1em;
  }
  .updating-status {
    animation-name: spin;
    animation-duration: 750ms;
    animation-iteration-count: infinite;
    animation-timing-function: linear; 
  }
  .reports-action-launch {
    position: relative;
    cursor: pointer;
  }
  .report-action-options {
    display: none;
  }
  .active-options {
    display: block !important;  
  }

  .firmware-rollout-area {
    height: 185px;
    overflow: auto;
    &::-webkit-scrollbar {
      width: 5px;
      height: 10px;
    }

    &::-webkit-scrollbar-track {
      background: #f1f1f1;
    }

    &::-webkit-scrollbar-thumb {
      background: #aaa;
      transition: all 0.2s;

      &:hover {
        background: #999;
      }
    }
  }
  .highlight {
    color: #0f74bb;
  }
  

  @keyframes spin {
    from {
        transform:rotate(0deg);
    }
    to {
        transform:rotate(360deg);
    }
  }

  .cm-scroll-bar {
    &::-webkit-scrollbar {
      width: 5px;
      height: 10px;
    }

    &::-webkit-scrollbar-track {
      background: #f1f1f1;
    }

    &::-webkit-scrollbar-thumb {
      background: #aaa;
      transition: all 0.2s;

      &:hover {
        background: #999;
      }
    }
  }
  .grey-text {
    color: #aaa !important;
    font-size: 14px;
    font-weight: 400;
  }
  #builds-table {
		.v-data-table__wrapper {
			overflow-x: visible !important;
			overflow-y: visible !important;
		}
  }
</style>
